function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// ----------------------------------------------------------------------------
// Product Form Web Component: iamProductGallery <iam-product-gallery>
// Extends: iamFormElement
// ----------------------------------------------------------------------------
// Parent component responsible for managing the product media gallery.
// ----------------------------------------------------------------------------
// Customization:
// - Enable `featureSlider` to add a slider to the gallery.
// - Enable `productZoom` to add zoom functionality to the gallery.
// - Enable `galleryVideo` to add muted-autoplay video functionality to the gallery.
// ----------------------------------------------------------------------------
// Event Triggers:
// - `productForm:gallery:init` → Fired when the gallery is initialized to allow
//                                other modules to hook in.
// ----------------------------------------------------------------------------
// Gotchas:
// - `sectionId` is extracted from `data-section-id`, ensure it's set correctly
//   on the component
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Helpers
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import iamFormElement from 'scripts/classes/iamFormElement';

// Styles
import './_product-gallery.scss';

// Modules
import './modules/galleryVideo';
import { FeatureSlider } from './modules/featureSlider';
import './modules/productZoom';

// -------------------------------------
// Web Component
// -------------------------------------

class iamProductGallery extends iamFormElement {
  /**
   * Initialize the component when the product form is initialized
   */
  onFormInit() {
    this.sectionId = this.dataset.sectionId;
    this.gallerySurface = this.querySelector('[data-product-gallery-surface]');
    this._onVariantGalleryChange = this.onVariantGalleryChange.bind(this);
    iamotaEventHandler.subscribe('productForm:variant:changed', this._onVariantGalleryChange, {
      context: this.iamForm,
      priority: 5,
      source: "product-gallery.js"
    });
    iamotaEventHandler.trigger('productForm:gallery:init', {
      iamProductGallery: this
    }, {
      context: this
    });
  }

  /**
   * Replace hero + mobile swiper + below-fold grid from the product.render
   * alternate template (?view=render — templates/products/product.render.json).
   */
  onVariantGalleryChange(_ref) {
    var _this = this;
    return _asyncToGenerator(function* () {
      var variant = _ref.variant;
      if (!(variant !== null && variant !== void 0 && variant.id) || !_this.gallerySurface) return;
      if (_this._lastGalleryVariantId === variant.id) return;
      var productRoot = _this.closest('.product');
      var grid = productRoot === null || productRoot === void 0 ? void 0 : productRoot.querySelector('[data-product-gallery-grid]');
      if (!grid) return;
      _this.setLoading(true);
      var requestedVariantId = variant.id;
      try {
        var _this$featureSlider, _this$featureSlider$d;
        var fetchUrl = new URL(window.location.href);
        fetchUrl.searchParams.set('view', 'render');
        fetchUrl.searchParams.set('variant', String(requestedVariantId));
        var response = yield fetch(fetchUrl.toString(), {
          credentials: 'same-origin',
          headers: {
            Accept: 'text/html'
          }
        });
        if (!response.ok) {
          throw new Error("Gallery render fetch failed (".concat(response.status, ")"));
        }
        var html = yield response.text();
        var current = _this.iamForm.getCurrentVariant();
        if (!current || current.id !== requestedVariantId) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incomingRoot = doc.querySelector('[data-main-product-gallery-ajax-root]');
        if (!incomingRoot) return;
        (_this$featureSlider = _this.featureSlider) === null || _this$featureSlider === void 0 || (_this$featureSlider$d = _this$featureSlider.destroy) === null || _this$featureSlider$d === void 0 || _this$featureSlider$d.call(_this$featureSlider);
        var nextSurface = incomingRoot.querySelector('[data-product-gallery-surface]');
        var nextGrid = incomingRoot.querySelector('[data-product-gallery-grid]');
        if (nextSurface) {
          _this.gallerySurface.innerHTML = nextSurface.innerHTML;
        }
        if (nextGrid) {
          grid.replaceWith(document.importNode(nextGrid, true));
        }
        _this.featureSlider = new FeatureSlider(_this);
        _this._lastGalleryVariantId = variant.id;
      } catch (error) {
        console.error('productForm: Error fetching gallery (?view=render):', error);
      } finally {
        _this.setLoading(false);
      }
    })();
  }
}
customElements.define('iam-product-gallery', iamProductGallery);